module.exports = __webpack_public_path__ + "img/pic5.9d38f91d.jpg";